// extracted by mini-css-extract-plugin
module.exports = {"listWrapper":"LanguageSelectorList_listWrapper__4rDMn"};